// Parts
import { createAction } from '@reduxjs/toolkit';

const dashboardAsyncAction = Object.freeze({
  getDashboardCalendarSettingsAsync: createAction('GET_DASHBOARD_CALENDAR_SETTINGS_ASYNC'),
});

export const { getDashboardCalendarSettingsAsync } = dashboardAsyncAction;
